import { noticeIcon } from '../../utils/icons';

const Notice = () => {
    return <div className='bsbNotice'>
        <div className="icon">{noticeIcon}</div>
        <p>Only work in front-end</p>
    </div>
}
export default Notice;